module.exports = __webpack_public_path__ + "static/img/career-course-syjc.851ba2e1.png";